// extracted by mini-css-extract-plugin
export default {"card":"Card_card__zQfcO","favorite":"Card_favorite__xIvHZ","plus":"Card_plus__4m90h"};